import { lazy } from 'react'

export const IntroGoogleVariant1 = lazy(() => import('./IntroGoogleVariant1'))
export const IntroGoogleVariant4 = lazy(() => import('./IntroGoogleVariant4'))
export const IntroGoogleVariant5 = lazy(() => import('./IntroGoogleVariant5'))
